import { AxiosError } from "axios";

export * from "./localStorage";
export * from "./collection";
export * from "./pagination";
export * from "./searchParams";
export * from "./debounce";

export const getErrorMessage = (err: any) => {
  return (err as AxiosError).response?.data?.errorMessage;
};
